.screen {
	min-height: 100%;
	padding: var(--space-5);
	/* Room for the floating Add button (it sits above the tab bar) so it
	   never covers the last row. */
	padding-bottom: calc(var(--space-5) + 64px);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.error {
	padding: var(--space-3) var(--space-4);
	background: color-mix(in srgb, var(--accent-rose) 14%, var(--surface-card));
	border-radius: var(--radius-md);
	color: var(--ink);
	font-size: 0.9rem;
}

/* Two columns on phones (a full-width column wastes space), stepping to three
   as the viewport widens up to --screen-max. */
.grid {
	list-style: none;
	margin: 0;
	padding: 0;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: var(--space-4);
}

@media (min-width: 560px) {
	.grid {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
}

.grid > li {
	display: block;
}

.empty {
	padding: var(--space-5) 0;
	margin: 0;
	color: var(--ink-muted);
	text-align: center;
}

.retry {
	background: none;
	border: none;
	color: var(--accent-sage);
	font: inherit;
	cursor: pointer;
	padding: 0;
	text-decoration: underline;
}
